import { BOTTOM_NAVIGATION_ID, ESPOT_MENUS } from '@/components/content/Header/constants';
import { HeaderAccount } from '@/components/content/Header/parts/Account';
import { DepartmentsOptionHeader } from '@/components/content/Header/parts/DepartmentsOption';
import { EmarketingSpotMenuDrawer } from '@/components/content/Header/parts/EmarketingSpotMenuDrawer';
import { MyRecentOrdersHeader } from '@/components/content/Header/parts/MyRecentOrders';
import {
	headerButtonsContainerSX,
	headerFooterContainerSX,
	headerFooterEspotContainerSX,
} from '@/components/content/Header/styles/stickyMobileBottomHeader';
import { useSettings } from '@/data/Settings';
import { Box, Paper, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useEffect, useState, type FC } from 'react';

export const StickyMobileBottomHeader: FC = () => {
	const theme = useTheme();
	const { settings } = useSettings();
	const isMobileApp = settings.isMobileApp;
	const [isKeyboardOpen, setIsKeyboardOpen] = useState(false);

	useEffect(() => {
		if (typeof window === 'undefined' || !('visualViewport' in window)) {
			return;
		}

		const handleResize = () => {
			const innerHeight = window.innerHeight;
			const viewportHeight = window.visualViewport!.height;
			setIsKeyboardOpen(innerHeight > viewportHeight);
		};

		window.visualViewport!.addEventListener('resize', handleResize);
		window.visualViewport!.addEventListener('scroll', handleResize);
		handleResize();

		return () => {
			window.visualViewport!.removeEventListener('resize', handleResize);
			window.visualViewport!.removeEventListener('scroll', handleResize);
		};
	}, []);

	if (isMobileApp) {
		return null;
	}

	return (
		<Paper
			component="footer"
			sx={{
				...headerFooterContainerSX(theme),
				display: isKeyboardOpen ? 'none' : 'flex',
			}}
			id={BOTTOM_NAVIGATION_ID}
		>
			<Stack
				direction="row"
				alignItems="center"
				justifyContent="space-between"
				spacing={2}
				py={2}
				sx={headerButtonsContainerSX(theme)}
			>
				<DepartmentsOptionHeader />
				{ESPOT_MENUS.map(({ trigger, title, items }) => (
					<Box key={trigger} sx={headerFooterEspotContainerSX}>
						<EmarketingSpotMenuDrawer
							menuDynamicTriggerEspot={trigger}
							menuDynamicTitleEspot={title}
							menuDynamicsItemsEspot={items}
						/>
					</Box>
				))}

				<MyRecentOrdersHeader />
				<HeaderAccount mobileBreakpoint="md" />
			</Stack>
		</Paper>
	);
};
